const container = {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    maxW: "100%",
    mx: "auto",
    w: {
      base: "100%",
      xs: "100%",
      sm: "35rem",
      md: "44rem",
      lg: "57rem",
      xl: "75rem",
      "2xl": "87.5rem",
    },
    mt: { base: 14, lg: 20 },
    mb: { base: 14, lg: 20 },
    px: {
      base: 4,
      md: 0,
    },
  },
}

export default container
